import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { NovoCalculoPropostaVencida } from 'src/app/aplicacao/models/novo-calculo-proposta-vencida.model';
import { OffcanvasService } from 'src/app/shared/services/offcanvas.service';

@Component({
  selector: 'app-formulario-solicitar-novo-calculo',
  templateUrl: './formulario-solicitar-novo-calculo.component.html',
  styleUrls: ['./formulario-solicitar-novo-calculo.component.scss']
})
export class FormularioSolicitarNovoCalculoComponent {
  @Input() propostaId;
  @Output() onSubmitSuccess: EventEmitter<any> = new EventEmitter();
  @Output() onClickFechar: EventEmitter<any> = new EventEmitter();
  model = new NovoCalculoPropostaVencida();
  validarFormulario = true;
  subscrition = new Subscription();
  
  constructor( private offcanvasService: OffcanvasService ) {}
  
  ngOnInit() {
    this.subscrition = this.offcanvasService.aoFecharOffcanvas.subscribe({
      next: () => this.limparFormulario()
    });
  }

  ngOnDestroy() {
    this.subscrition.unsubscribe();
  }

  limparFormulario() {
    this.model = new NovoCalculoPropostaVencida()
  }

  enviar(): void {
    this.model.asForm.controls.propostaId.setValue(this.propostaId);
    if(this.model.form.valid) {
      this.validarFormulario = true;
      this.onSubmitSuccess.emit(this.model.form.value);
      this.limparFormulario();
    } else {
      this.validarFormulario = false;
    }
  }

  fechar(){
    this.onClickFechar.emit(true);
    this.limparFormulario();
  }
}
